import { Box, Button, Grid, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import CustomTable from "../../components/common/Table";
// import CustomTextField from "../../components/textField/index";
// import InputField from "../../components/common/InputField/InputField";
import InputField from "../../components/common/new/InputField/InputField";
import Toast from "../../components/common/Toast";
import { FRIEND_TRANSFER_REMARK_COL } from "../../contants/table/friendTransfer";
import { fetchTransferFriendRemarksData } from "../../redux/actions/friend";
import { fetchIntroductionRemarksData } from "../../redux/actions/introduction";
import { fetchTransferMemberRemarksData } from "../../redux/actions/member";
import Friends from "../../services/api/friend";
import ViewIntroduction from "../../services/api/viewIntroduction";
import tableStyle from "../../theme/styles/table";
import { convertDateTimeToDate } from "../../utils/dateAndTime";
import IntroductionRemark from "./IntroductionRemark";

import { ROUTES } from "../../utils/constants";
import Styles from "./styles";
import Member from "../../services/api/member";
import { INTRODUCTION_TYPE, MEMBER_TYPE } from "../../contants";
import Colors from "../../theme/colors";

const getRemarkRows = (data) =>
  data?.map((remarker, i) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell>{i + 1}. </TableCell>
      <TableCell sx={{ display: "flex" }}>
        <Box
          component="img"
          sx={{
            height: 22,
            width: 22,
            borderRadius: "50%",
            marginRight: ".5rem",
          }}
          alt="The house from the offer."
          src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
        />{" "}
        {remarker.createdByUser?.fullName}{" "}
      </TableCell>
      <TableCell>{remarker?.data?.message} </TableCell>
      <TableCell>{convertDateTimeToDate(remarker?.createdAt)} </TableCell>
    </TableRow>
  ));

function Remarks() {
  const navigate = useNavigate();
  const [remarkText, setRemarkText] = useState("");
  const [showToast, setShowToast] = useState(null);
  const { type, id } = useParams();
  const selectedIntroduction = useSelector(
    (state) => state.view_introduction.selectedIntroduction
  );
  const dispatch = useDispatch();
  const selectedPendingTransfer = useSelector(
    (state) => state.view_friends.selectedPendingTransfer
  );
  const selectedMemberPendingTransfer = useSelector(
    (state) => state.view_members.selectedMemberPendingTransfer
  );
  console.log(selectedMemberPendingTransfer);

  const getTableData = () => {
    if (type === INTRODUCTION_TYPE) return selectedIntroduction;
    if (type === MEMBER_TYPE) return selectedMemberPendingTransfer;
    return selectedPendingTransfer;
  };

  const getRemarkData = () => {
    if (type === INTRODUCTION_TYPE)
      return selectedIntroduction?.remarks?.data || [];
    if (type === MEMBER_TYPE)
      return selectedMemberPendingTransfer?.remarks?.data || [];
    return selectedPendingTransfer?.remarks?.data || [];
  };

  const onRemarkSubmit = async () => {
    try {
      const body = {
        data: {
          message: remarkText,
        },
      };
      let response = null;
      if (type === INTRODUCTION_TYPE) {
        response = await ViewIntroduction.addRemark({ id, data: body });
      } else if (type === MEMBER_TYPE) {
        response = await Member.addRemarkForMemberTransfer({
          memberId: selectedMemberPendingTransfer.memberId,
          transfereRequestId: id,
          data: body,
        });
      } else {
        response = await Friends.addRemarkForFriendTransfer({
          friendId: selectedPendingTransfer.friendId,
          transfereRequestId: id,
          data: body,
        });
      }

      if (response.code === 201) {
        setShowToast({
          message: "Remark submitted successfully",
          severity: "success",
        });

        setTimeout(() => {
          if (type === INTRODUCTION_TYPE) {
            navigate(`/${ROUTES.INTRODUCTION_VIEW.path}`);
          } else if (type === MEMBER_TYPE) {
            navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
          } else {
            navigate(`/${ROUTES.FRIEND_TRANSFER.path}`);
          }
        }, 2000);
      }
    } catch (error) {
      setShowToast({ message: error.message, severity: "error" });
      Sentry.captureException(error);
    }
  };

  const onBack = () => {
    if (type === INTRODUCTION_TYPE) {
      navigate(`/${ROUTES.INTRODUCTION_VIEW.path}`);
    } else if (type === MEMBER_TYPE) {
      navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
    } else {
      navigate(`/${ROUTES.FRIEND_TRANSFER.path}`);
    }
  };

  useEffect(() => {
    if (type === INTRODUCTION_TYPE) {
      fetchIntroductionRemarksData(dispatch, id);
    } else if (type === MEMBER_TYPE) {
      fetchTransferMemberRemarksData(dispatch, id);
    } else {
      fetchTransferFriendRemarksData(dispatch, id);
    }
  }, [type, id]);

  return (
    <Box style={Styles.container}>
      <Box style={Styles.tableContainer}>
        <IntroductionRemark data={getTableData()} />
      </Box>
      <Box style={Styles.formContainer}>
        <Box>
          <Grid md={8} xs={8}>
            <InputField
              type="text"
              fullWidth
              defaultValue=""
              key="remark"
              name="remark"
              label="Your Remark"
              required
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
            />
          </Grid>
          <Grid container spacing={2}>
            <Box>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "#FFFFFF",
                  width: "150px",
                  height: "50px",
                  border: "1px solid #043D90",
                  borderRadius: "2rem",
                  color: "#043D90",
                  px: "2.2rem",
                  py: ".8rem",
                  fontSize: "18px",
                  fontWeight: "500",
                  textTransform: "capitalize",
                  mt: "60px",
                }}
                onClick={onBack}
              >
                Back
              </Button>
            </Box>

            <Box>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: Colors.midnightBlue,
                  width: "150px",
                  height: "50px",
                  borderRadius: "2rem",
                  px: "2.2rem",
                  py: ".8rem",
                  fontSize: "18px",
                  fontWeight: "500",
                  textTransform: "capitalize",
                  mt: "60px",
                  ml: 10,
                }}
                onClick={onRemarkSubmit}
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </Box>
      </Box>
      <Box>
        <CustomTable
          columns={FRIEND_TRANSFER_REMARK_COL}
          rows={getRemarkRows(getRemarkData())}
        />
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default Remarks;
